import { PrimaryButton } from '@/components/button/button-component';
import { BsImage } from 'react-icons/bs';
import styled from 'styled-components';

const HeaderButtonStyled = styled(PrimaryButton)`
  padding: 10px;
  margin: 4px;
`;

const Thumbnail = styled.img`
  color: ${({ theme }) => theme.COLOR_GREY4};
  height: 40px;
`;

const IconContainer = styled.div`
  display: flex;
  align-items: center;
  background-color: ${({ theme }) => theme.COLOR_BG_DARK};
  width: min-content;
`;

const ImageContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 72%;
`;

const NoThumbnail = styled(BsImage)`
  color: ${({ theme }) => theme.COLOR_GREY4};
  height: 20px;
  width: 20px;
  margin: 10px;
`;

const styledTemplateAll = {
  HeaderButtonStyled,
  Thumbnail,
  ImageContainer,
  IconContainer,
  NoThumbnail,
};

export default styledTemplateAll;
